<template>
  <v-container fluid fill-height>
    <v-layout row wrap fill-height>
      <v-flex md12>
        <v-card class="h-100" style="z-index: 0">
          <vl-map
            v-if="homeAP_LAT"
            :load-tiles-while-animating="true"
            :load-tiles-while-interacting="true"
            data-projection="EPSG:4326"
            @click="closeFlightInfo()"
          >
            <vl-view
              :zoom.sync="zoom"
              :min-zoom="Number(4)"
              :center.sync="center"
              :rotation.sync="rotation">
            </vl-view>

            <div class="text-xs-center">
              <v-dialog v-model="preloader" hide-overlay persistent width="300">
                <v-card color="blue" dark>
                  <v-card-text>
                    Загрузка данных
                    <v-progress-linear indeterminate color="white" class="mb-0" height="3"></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>

            <vl-overlay
              v-if="flightsExistence"
              :position="[homeAP_LON, homeAP_LAT]"
              positioning="center-right"
              style="z-index: 0"
            >
              <v-chip
                id="home-ap"
                color="teal"
                text-color="white"
                disabled>{{ homeApName }}</v-chip>
            </vl-overlay>

            <!-- рейсы в домашний ап -->

            <template v-if="arrFlights">
              <div
                :key="'dep-processed-line-' + item.ID"
                v-for="(item, index) in flightsToHomeAP"
              >
                <vl-feature
                  :id="'dep-processed-line-' + item.ID"
                >
                  asd
                  <vl-geom-line-string
                    color='red'
                    :coordinates="[
                      [parseFloat(item.LON), parseFloat(item.LAT)],
                      [parseFloat(homeAP_LON), parseFloat(homeAP_LAT)],
                    ]"
                  ></vl-geom-line-string>
                  <vl-style-box>
                    <vl-style-stroke :width="2" color="grey"></vl-style-stroke>
                  </vl-style-box>
                </vl-feature>
              </div>

              <div
                v-for="(item, index) in arrFlights"
                :key="`dep-line-${item.ID}`"
              >
                <vl-feature
                  :id='`dep-line-${item.ID}`'
                >
                  <vl-geom-line-string
                    :coordinates="[
                      [parseFloat(item.LON), parseFloat(item.LAT)],
                      [parseFloat(flightsToHomeAP[index].LON), parseFloat(flightsToHomeAP[index].LAT)],
                    ]"
                  ></vl-geom-line-string>
                  <vl-style-box>
                    <vl-style-stroke :width="3" color="green"></vl-style-stroke>
                  </vl-style-box>
                </vl-feature>
              </div>
              <div
                :key="'dep-cityName-' + item.ID"
                v-for="(item, index) in arrFlights"
              >

                <vl-overlay
                  :id="'dep-cityName-' + item.ID"
                  :position="[parseFloat(item.LON), parseFloat(item.LAT)]"
                  positioning="center-right"
                  style="z-index: 0"
                  @click.native="flightInfo(item, $event)"
                >
                  <v-chip color="success" text-color="white">{{ item.cityName }}</v-chip>
                </vl-overlay>
              </div>

              <div
                :key="'dep-plane-' + item.ID"
                v-for="(item, index) in flightsToHomeAP"
              >
                <vl-overlay
                  :id="'dep-plane-' + item.ID"
                  :position="[parseFloat(item.LON), parseFloat(item.LAT)]"
                  positioning="center-center"
                  style="z-index: 1; cursor: pointer"
                  @click.native="flightInfo(item, $event)"
                >
                  <v-icon
                    large
                    color="green darken-2"
                    :style="`transform: rotate(${item.rotate}deg); -webkit-text-stroke: 1.4px #1b6803;`"
                  >flight</v-icon>
                </vl-overlay>
              </div>
            </template>

            <!-- рейсы из домашнего ап -->

            <template v-if="depFlights">
              <div
                :key="'arr-processed-line-' + item.ID"
                v-for="(item, index) in flightsFromHomeAP"
              >
                <vl-feature
                  v-if='item.LAT > -90'
                  :id="'arr-processed-line-' + item.ID"
                >
                  <vl-geom-line-string
                    :coordinates="[
                      [parseFloat(item.LON), parseFloat(item.LAT)],
                      [parseFloat(depFlights[index].LON), parseFloat(depFlights[index].LAT)],
                    ]"
                  ></vl-geom-line-string>
                  <vl-style-box>
                    <vl-style-stroke :width="2" color="grey"></vl-style-stroke>
                  </vl-style-box>
                </vl-feature>
              </div>
            <div
              :key="'arr-line-' + item.ID"
              v-for="(item, index) in flightsFromHomeAP">
              <vl-feature
                v-if='item.LAT > -90'
                :id="'arr-line-' + item.ID"
              >
                <vl-geom-line-string
                  :coordinates="[
                  [parseFloat(homeAP_LON), parseFloat(homeAP_LAT)],
                  [parseFloat(item.LON), parseFloat(item.LAT)],
                ]"
                ></vl-geom-line-string>
                <vl-style-box>
                  <vl-style-stroke :width="3" color="blue"></vl-style-stroke>
                </vl-style-box>
              </vl-feature>
            </div>
            <div
              :key="'arr-cityName-' + item.ID"
              v-for="(item, index) in depFlights"
            >
              <vl-overlay
                :id="'arr-cityName-' + item.ID"
                :position="[parseFloat(item.LON), parseFloat(item.LAT)]"
                positioning="center-right"
                style="z-index: 0"
                @click.native="flightInfo(item, $event)"
              >
                <v-chip color="primary" text-color="white">{{ item.cityName }}</v-chip>
              </vl-overlay>
            </div>
            <div
              :key="'arr-plane-' + item.ID"
              v-for="(item, index) in flightsFromHomeAP"
            >
              <vl-overlay
                :id="'arr-plane-' + item.ID"
                :position="[parseFloat(item.LON), parseFloat(item.LAT)]"
                positioning="center-center"
                style="z-index: 1; cursor: pointer"
                @click.native="flightInfo(item, $event)"
              >
                <v-icon
                  large
                  color="blue darken-2"
                  :style="`transform: rotate(${item.rotate - 180}deg); -webkit-text-stroke: 1.4px #04055e;`"
                >flight</v-icon>
              </vl-overlay>
            </div>
            </template>

            <vl-layer-tile id="osm">
              <vl-source-xyz :url="url"></vl-source-xyz>
            </vl-layer-tile>

            <!-- инфо о полёте-->
            <v-slide-x-reverse-transition>
              <v-card class="detail-card" max-width="374" v-if="showFlightInfo">
                <v-container>
                  <v-toolbar dense color="white" class="elevation-1">
                    <v-toolbar-title class="body-1">Информация о рейсе</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeFlightInfo()">
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-img
                    :src="`/static/img/ac-logos/${currentFlightInfo.acIATA}.svg`"
                    aspect-ratio="3"
                    contain></v-img>

                  <v-layout row>
                    <v-flex>
                      <v-card :color="currentFlightInfo.flightType === 'arr' ? 'green' : 'blue darken-3'">
                        <v-card-title class="justify-left">
                          <v-icon large color="white">flight</v-icon>
                          <div style="position: absolute; right: 220px">
                            <span class="white--text" title="Номер рейса">{{ currentFlightInfo.flightNumber }}</span><br />
                            <span class="white--text" title="Тив ВС">{{ currentFlightInfo.planeType }}</span>
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-card style="height: 100%">
                        <v-card-title fill-height style="display: grid; place-content: center">
                          <div style="text-align: center">
                            <div class="headline">
                              {{ currentFlightInfo.flightType === 'arr' ? currentFlightInfo.IATA : homeApIATA }}
                            </div>
                            <span>
                              {{ currentFlightInfo.flightType === 'arr' ? currentFlightInfo.cityName : homeApName }}
                            </span>
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                    <v-flex xs12>
                      <v-card style="height: 100%">
                        <v-card-title style="display: grid; place-content: center">
                          <div style="text-align: center">
                            <div class="headline">
                              {{ currentFlightInfo.flightType === 'dep' ? currentFlightInfo.IATA : homeApIATA }}
                            </div>
                            <span>
                              {{ currentFlightInfo.flightType === 'dep' ? currentFlightInfo.cityName : homeApName }}
                            </span>
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-card>
                        <v-card-title>
                          <div>
                            <span class="grey--text">Отправление</span><br />
                            <span>Плановое: {{ currentFlightInfo.depTimePlan }}</span><br />
                            <span>Фактическое: {{ currentFlightInfo.depTimeFact }}</span>
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-card>
                        <v-card-title>
                          <div>
                            <span class="grey--text">Прибытие</span><br />
                            <span>Плановое: {{ currentFlightInfo.arrTimePlan }}</span><br />
                            <span>Расчетное: {{ currentFlightInfo.arrTimeCalc }}</span>
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-slide-y-transition>
                    <v-layout row v-if="currentFlightInfo.delay != ''">
                      <v-flex>
                        <v-card>
                          <v-card-title>
                            <div>
                              <span class="grey--text">Задержка</span><br />
                              <div v-for="delay in currentFlightInfo.delay" :key="delay.Code">
                                <span>Код: {{ delay.Code }} - {{ delay.CodeTitle }}</span><br />
                                <span>Время: {{ delay.Time }}</span>
                              </div>
                            </div>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-slide-y-transition>
                </v-container>
              </v-card>
            </v-slide-x-reverse-transition>
          </vl-map>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'
import moment from 'moment'

export default {
  data() {
    return {
      zoom: 4,
      center: [0, 0],
      perronPreloader: true,
      rotation: 0,
      flightsExistence: false,
      showFlightInfo: false,
      firstOpen: true,
      currentFlightInfo: {},
      flightObjects: [],
      homeAP_LAT: 0,
      homeAP_LON: 0,
      homeApName: '',
      homeApIATA: '',

      arrFlights: [],
      flightsToHomeAP: [],

      depFlights: [],
      flightsFromHomeAP: [],

      url: 'https://mt.google.com/vt/lyrs=m&hl=ru&x={x}&y={y}&z={z}',
    }
  },
  methods: {
    flightInfo(flight) {
      this.currentFlightInfo = flight
      this.showFlightInfo = true
    },

    closeFlightInfo() {
      this.showFlightInfo = false
    },

    setDataArray(flightArray) {
      flightArray.forEach((flight) => {
        flight['rotate'] = 0
        flight['flightTime'] = 0

        flight.LON = this.convertCoords(flight.LON)
        flight.LAT = this.convertCoords(flight.LAT)
        flight.flightTime = this.timeDiff(flight.depTimeFact.slice(0, 5), flight.arrTimeCalc.slice(0, 5))
        if (flight.flightType === 'arr') {
          flight.rotate = this.rotateValue(flight)
        }

        if(flight.depTimeFact.slice(7,9) === flight.depTimePlan.slice(7,9))
        {
          flight.depTimeFact = flight.depTimeFact.slice(0,5)
          flight.depTimePlan = flight.depTimePlan.slice(0,5)
          flight.arrTimeCalc = flight.arrTimeCalc.slice(0,5)
          flight.arrTimePlan = flight.arrTimePlan.slice(0,5)
        }
      })
    },
    setFlightData() {
      let homeAp = store.getters['getAirportPosition']

      this.homeAP_LAT = parseFloat(homeAp[1].toFixed(2))
      this.homeAP_LON = parseFloat(homeAp[0].toFixed(2))
      this.center = [this.homeAP_LON, this.homeAP_LAT]

      this.flightObjects = store.getters['maps/getFlightObjects']

      this.flightsToHomeAP = JSON.parse(JSON.stringify(this.flightObjects.arr))
      this.flightsFromHomeAP = JSON.parse(JSON.stringify(this.flightObjects.dep))

      let exist_flight = this.flightsToHomeAP[0] || this.flightsFromHomeAP[0]
      this.flightsExistence = exist_flight ? true : false

      this.homeApIATA = exist_flight ? exist_flight.homeAP : ''
      this.homeApName = exist_flight ? exist_flight.homeCity : ''

      this.setDataArray(this.flightsToHomeAP)
      this.setDataArray(this.flightsFromHomeAP)

      this.arrFlights = JSON.parse(JSON.stringify(this.flightsToHomeAP))
      this.depFlights = JSON.parse(JSON.stringify(this.flightsFromHomeAP))

      this.flightsFromHomeAP.forEach((el) => {
        el.rotate = this.rotateValue(el)
        el.LON = this.homeAP_LON
        el.LAT = this.homeAP_LAT
      })
    },
    rotateValue(Airport) {
      let plane_rotate = (Math.atan((this.homeAP_LAT - Airport.LAT) / (this.homeAP_LON - Airport.LON)) * 180) / Math.PI
      plane_rotate = plane_rotate < 0 ? plane_rotate + 180 : plane_rotate

      // рассчет угла поворота с учетом четверти
      let result = Airport.LON > this.homeAP_LON && Airport.LAT > this.homeAP_LAT ? 260 - plane_rotate //1
                 : Airport.LON < this.homeAP_LON && Airport.LAT < this.homeAP_LAT ? 85 - plane_rotate //2
                 : Airport.LON > this.homeAP_LON && Airport.LAT < this.homeAP_LAT ? 90 - plane_rotate //3
                 : 280 - plane_rotate //4

      return result
    },

    convertCoords(data) {
      if (data.startsWith('S'))
      {
        let LAT = data.replace('S', '-').replace('.', '')
        data = LAT.substring(0, 4) + '.' + LAT.substring(2)
      }
      else if (data.startsWith('N'))
      {
        let LAT = data.replace('N', '').replace('.', '')
        data = LAT.substring(0, 2) + '.' + LAT.substring(2)
      }
      else if (data.startsWith('W'))
      {
        let LON = data.replace('W', '-').replace('.', '')
        data = LON.substring(0, 4) + '.' + LON.substring(3)
      }
      else
      {
        let LON = data.replace('E', '').replace('.', '')
        data = LON.substring(0, 3) + '.' + LON.substring(3)
      }

      return parseFloat(data)
    },

    timeDiff(start, end) {
      let today = new Date()
      let dd = String(today.getDate() - 1).padStart(2, '0')
      let mm = String(today.getMonth() + 1).padStart(2, '0')
      let yyyy = today.getFullYear()

      today = mm + '/' + dd + '/' + yyyy + ' '

      let dateStart = new Date(today + start).getTime()
      let dateEnd = new Date(today + end).getTime()

      let timeDiff = dateEnd - dateStart

      timeDiff = timeDiff < 0 ? 86400000 + timeDiff : timeDiff

      return timeDiff
    },

    updateCoordinates(current_flight, flight_data) {
      current_flight.forEach(({}, idx) => {
        let x1 = flight_data[idx].LON,
            y1 = flight_data[idx].LAT,
            x2 = this.homeAP_LON,
            y2 = this.homeAP_LAT,
            flight_time = current_flight[idx].flightTime,
            flight_length = Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2),
            x_offset = 0,
            now = new Date().toTimeString().replace(/ .*/, ''),
            current_flight_time = this.timeDiff(current_flight[idx].depTimeFact, now),
            current_flight_length = (flight_length * current_flight_time) / flight_time,
            plane_speed = (flight_length / flight_time) * 5000,
            angle = (Math.atan((y2 - y1) / (x2 - x1)) * 180) / Math.PI
        angle = angle < 0 ? angle + 180 : angle
        angle = angle > 90 ? 180 - angle : angle
        if (current_flight[idx].flightType === 'dep') {
          ;[x1, x2] = [x2, x1]
          ;[y1, y2] = [y2, y1]
        }


        if (current_flight_length < flight_length) {
          x_offset = this.firstOpen
            ? current_flight_length * Math.abs(Math.cos(angle))
            : plane_speed * Math.abs(Math.cos(angle))

          let x_move = x1 < x2
                ? current_flight[idx].LON + x_offset
                : current_flight[idx].LON - x_offset,
              y_move = ((current_flight[idx].LON - x1) * (y2 - y1)) / (x2 - x1) + y1,
              diff = current_flight_length - Math.sqrt((x_move - x1) ** 2 + (y_move - y1) ** 2)

           while (diff>0.001) {
              x_offset = diff * Math.abs(Math.cos(angle))

              x_move = x1 < x2 ? x_move + x_offset : x_move - x_offset
              y_move = ((x_move - x1) * (y2 - y1)) / (x2 - x1) + y1

              diff = current_flight_length - Math.sqrt((x_move - x1) ** 2 + (y_move - y1) ** 2)
              }

          current_flight[idx].LON = x_move
          current_flight[idx].LAT = y_move
        }
        else
        {
          current_flight[idx].LON = x2
          current_flight[idx].LAT = y2
          const date = new Date(current_flight[idx].depTimeFact_utc_db)
          let delay_display = current_flight[idx].flightTime + 5*60*1000,
              now = new Date().getTime(),
              diff = date + delay_display - now

          if (diff>0) {
              setTimeout(function () {
              current_flight.splice(idx, 1)
              flight_data.splice(idx, 1)
              }, diff)
            }
          else {
              current_flight.splice(idx, 1)
              flight_data.splice(idx, 1)
            }
        }
      })
    },
    planeMove() {
      this.updateCoordinates(this.flightsFromHomeAP, this.depFlights)
      this.updateCoordinates(this.flightsToHomeAP, this.arrFlights)
    },
  },
  computed: {
    preloader: {
      get() {
        return store.getters['maps/getPerronPreloader']
      },
    },
  },
  async mounted() {
    store.commit('setPageTitle', 'Карта разлёта')
    await this.$store.dispatch('maps/updateFlightObjects')

    this.setFlightData()
    this.planeMove()
    this.firstOpen = false
    setInterval(this.planeMove, 5000)
  },
}
</script>
<style>
#app .v-chip .v-chip__content {
  cursor: pointer;
  border: 1px solid white;
}

#app #home-ap .v-chip__content {
  cursor: default;
}
</style>
